import { CurrencyType, ItemType } from '../types';
export const tokenDecimals = {
  [CurrencyType.BUSD]: 18,
  [CurrencyType.THC]: 18,
  [CurrencyType.THG]: 18,
  [CurrencyType.GTHG]: 18,
  [CurrencyType.GTHC]: 18,
  [CurrencyType.WBNB]: 18,
  [CurrencyType.GOLD]: 18,
  [CurrencyType.BNB]: 18,
  [CurrencyType.GPP]: 18,
  [CurrencyType.GPT]: 18,
  [CurrencyType.BUSDT]: 18,
  [CurrencyType.GMQP]: 18
};
export const currencyName = {
  [CurrencyType.BUSD]: 'BUSD',
  [CurrencyType.THC]: 'THC',
  [CurrencyType.THG]: 'THG',
  [CurrencyType.GTHG]: 'THG',
  [CurrencyType.GTHC]: 'THC',
  [CurrencyType.WBNB]: 'WBNB',
  [CurrencyType.BNB]: 'BNB',
  [CurrencyType.GPP]: 'PP',
  [CurrencyType.BUSDT]: 'USDT',
  [CurrencyType.GOLD]: 'GOLD',
  [CurrencyType.GPT]: 'GPT',
  [CurrencyType.GMQP]: 'GMQP'
};
export const itemName = {
  [ItemType.TOURNAMENT_TICKET]: 'Tournament Ticket'
};
export const SYSTEM_DECIMALS = 8;